import React, { createContext, useContext, useState } from "react";

type NavigationContextType = {
    activeNav: string;
    setActiveNav: (nav: string) => void;
};

const NavigationContext = createContext<NavigationContextType | undefined>(
    undefined
);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [activeNav, setActiveNav] = useState("home"); // default

    return (
        <NavigationContext.Provider value={{ activeNav, setActiveNav }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => {
    const context = useContext(NavigationContext);
    if (!context)
        throw new Error("useNavigation must be used within NavigationProvider");
    return context;
};
